import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=bea52c8a&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=bea52c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea52c8a",
  null
  
)

export default component.exports